var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.stockHasFeedDetailList,
                  label: "Stock",
                  "item-value": "id",
                  "item-text": "description",
                  "return-object": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function({ item }) {
                      return [
                        _c("small", { staticClass: "blue-grey--text ml-2" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      ]
                    }
                  },
                  {
                    key: "item",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.id))
                        ]),
                        _c("small", { staticClass: "blue-grey--text ml-2" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.stock,
                  callback: function($$v) {
                    _vm.stock = $$v
                  },
                  expression: "stock"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: { label: "Unit", items: _vm.units },
                model: {
                  value: _vm.unit,
                  callback: function($$v) {
                    _vm.unit = $$v
                  },
                  expression: "unit"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Cost",
                  type: "number",
                  value: _vm.cost,
                  readonly: ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("v-text-field", {
                attrs: { label: "Quantity", type: "number" },
                model: {
                  value: _vm.quantity,
                  callback: function($$v) {
                    _vm.quantity = _vm._n($$v)
                  },
                  expression: "quantity"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "green", block: "", dark: "" },
                  on: { click: _vm.addToDetails }
                },
                [_c("span", [_vm._v("Add")])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }